package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class AuditEntriesResponse(val entries: List<AuditEntry>)
